export const apiPath = '/v2/users';
const actionType = 'ASSIGNABLE_USERS';

export default actionType;
